
export const defaultLocale = 'es';
export const localeOptions=[
    { id:'en',name:'English',icon:'flag-icon-us', short:'(US)'},
    { id:'es',name:'Español',icon:'flag-icon-es' },
    
];
